import { render, staticRenderFns } from "./ChooseRole.vue?vue&type=template&id=78e96e64&scoped=true"
import script from "./ChooseRole.vue?vue&type=script&lang=js"
export * from "./ChooseRole.vue?vue&type=script&lang=js"
import style0 from "./ChooseRole.vue?vue&type=style&index=0&id=78e96e64&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e96e64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78e96e64')) {
      api.createRecord('78e96e64', component.options)
    } else {
      api.reload('78e96e64', component.options)
    }
    module.hot.accept("./ChooseRole.vue?vue&type=template&id=78e96e64&scoped=true", function () {
      api.rerender('78e96e64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/loginModal/ChooseRole.vue"
export default component.exports